import { Component } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-show-on-map-venue-dialog',
	templateUrl: './show-on-map-venue-dialog.component.html',
	styleUrls: ['./show-on-map-venue-dialog.component.scss'],
})
export class ShowOnMapVenueDialogComponent {
	constructor(private popoverValue: PopoverController, public translate: TranslateService) {}

	title = '';
	isVenueOpen;
	static async show(popoverValue: PopoverController, { title, event, isVenueOpen }) {
		console.log(isVenueOpen);
		const popover = await popoverValue.create({
			component: ShowOnMapVenueDialogComponent,
			event: event,
			translucent: true,
			cssClass: 'popover-select-language',
			showBackdrop: false,
			componentProps: {
				title: title,
				isVenueOpen: isVenueOpen,
			},
		});

		await popover.present();
		const result = (await popover.onWillDismiss()).data;
		return result;
		// const modal = await modalCtrl.create({
		//   cssClass: 'info-modal auto-height',
		//   component: ShowOnMapVenueDialogComponent,
		//   componentProps: {
		//     title,
		//     event
		//   },
		//   showBackdrop: true,
		//   backdropDismiss: true,
		// });
		// await modal.present();

		// const result = (await modal.onDidDismiss()).data;
		// return result;
	}
	dismiss(value: boolean) {
		this.popoverValue.dismiss(value);
	}
	isVenueOpenFunc() {
		return this.isVenueOpen ? this.translate.instant('venue_suggestion.open') : this.translate.instant('venue_suggestion.close');
	}
}
